import { observer } from "mobx-react-lite";
import { LeadStatus } from "../../interfaces/ILead";
import { formatNumber } from "../../utils/utils";
import infoStyles from '../Info.module.css';
import LeadStatusWithIcon from "./LeadStatusWithIcon";

function LeadInfo({ address, ownerName, status, buildingSize, landSizeAcres, zoning, className, onClick }: ILeadInfoProps) {
    return (
        <div className={[infoStyles.container, className].join(" ")} onClick={onClick}>
            <div className={infoStyles.title}>{address}</div>
            <div className={infoStyles.description}>
                <LeadStatusWithIcon status={status as LeadStatus} /> - {ownerName}
            </div>
            <div className={infoStyles.description}>
                {[
                    !!buildingSize && `${formatNumber(buildingSize)} Sq-Ft`,
                    !!landSizeAcres && `${formatNumber(landSizeAcres)} Acres`,
                    !!zoning && `${zoning} Zoning`,
                ].filter(d => d).join(" - ")}
            </div>
        </div>
    );
}

export interface ILeadInfoProps {
    address: string | null;
    ownerName: string | null;
    status: string;
    buildingSize: number | null;
    landSizeAcres: number | null;
    zoning: string | null;
    className?: string;
    onClick?: () => void;
}

export default observer(LeadInfo);